/**
 * PATH: apps/assets/src/pages/BookingsPage.tsx
 * PURPOSE: Asset booking and scheduling
 */
import { EmptyRegister } from './emptyRegister'

export default function BookingsPage() {
  return (
    <EmptyRegister
      title="Bookings"
      detail="No asset bookings are connected."
    />
  )
}
